import { Rule } from 'antd/lib/form';
import React, { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { NamePath } from '~/utils/buildNamePath';
import { Form, PhoneNumberInput } from '..';

interface Props {
  name: NamePath;
  label?: string;
  disabled?: boolean;
  rules?: Rule[];
  [itemProps: string]: any;
}

const PhoneNumberFormItem: FC<Props> = (props) => {
  const { name, label, disabled, rules, ...itemProps } = props;
  const { t } = useTranslation();
  const [showErr, setShowErr] = useState(true);
  return (
    <Form.Item name={name} shouldUpdate noStyle rules={rules}>
      {(form) => {
        const hasError = (form.getFieldError(name) || []).length > 0;
        return (
          <Form.Item
            validateStatus={hasError && showErr ? 'error' : ''}
            label={label ?? t('Mobile Number')}
            name={name}
            style={{ marginBottom: '30px !important' }}
            help={
              hasError && showErr ? undefined : (
                <Trans t={t} i18nKey="For example <bdi>+971 55 123 4567</bdi>">
                  For example <bdi>+971 55 123 4567</bdi>
                </Trans>
              )
            }
            disabled={disabled}
            rules={rules}
            {...itemProps}
          >
            <PhoneNumberInput setShowErr={setShowErr} />
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default PhoneNumberFormItem;
